// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-iam-access-dialog-add-subjects-subjects-list__subjects {
  margin-top: 30px;
}
.dl-iam-access-dialog-add-subjects-subjects-list__subject {
  display: flex;
  padding: 10px 4px;
  border-bottom: 1px solid var(--g-color-line-generic);
}
.dl-iam-access-dialog-add-subjects-subjects-list__subject-info {
  flex: 1;
}
.dl-iam-access-dialog-add-subjects-subjects-list__delete-subject {
  margin-left: 10px;
}
.dl-iam-access-dialog-add-subjects-subjects-list__delete-subject-icon {
  opacity: 0.5;
}
.dl-iam-access-dialog-add-subjects-subjects-list__acl-popup-content {
  width: 540px;
  padding: var(--g-spacing-2);
}`, "",{"version":3,"sources":["webpack://./src/ui/components/IamAccessDialog/AddSubjects/SubjectsList/SubjectsList.scss"],"names":[],"mappings":"AACI;EACI,gBAAA;AAAR;AAGI;EACI,aAAA;EACA,iBAAA;EACA,oDAAA;AADR;AAII;EACI,OAAA;AAFR;AAKI;EACI,iBAAA;AAHR;AAMI;EACI,YAAA;AAJR;AAOI;EACI,YAAA;EACA,2BAAA;AALR","sourcesContent":[".dl-iam-access-dialog-add-subjects-subjects-list__subjects {\n  margin-top: 30px;\n}\n.dl-iam-access-dialog-add-subjects-subjects-list__subject {\n  display: flex;\n  padding: 10px 4px;\n  border-bottom: 1px solid var(--g-color-line-generic);\n}\n.dl-iam-access-dialog-add-subjects-subjects-list__subject-info {\n  flex: 1;\n}\n.dl-iam-access-dialog-add-subjects-subjects-list__delete-subject {\n  margin-left: 10px;\n}\n.dl-iam-access-dialog-add-subjects-subjects-list__delete-subject-icon {\n  opacity: 0.5;\n}\n.dl-iam-access-dialog-add-subjects-subjects-list__acl-popup-content {\n  width: 540px;\n  padding: var(--g-spacing-2);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
